export default __webpack_public_path__ + "static/media/samyukthas.c40fb533.jpg";